import { Injectable } from '@angular/core';

import { Observable, from as observableFrom, of as observableOf } from 'rxjs';
import { catchError, map, publishLast, refCount } from 'rxjs/operators';

import { CATALOG_TYPE, ProductsServiceBase } from '../baseBtl/catalog/products.service';
import { JsonCatalog } from './products/interface/context';

/**
 * This class represents the produts Service used to get catalog.
 */

@Injectable({
    providedIn: 'root',
})
export class ProductsService extends ProductsServiceBase {
    /**
     *
     * @example
     * ProductsService.getProducts()
     *
     */
    public getProducts(
        type: CATALOG_TYPE = CATALOG_TYPE.DEFAULT,
        allowedAttributes: string[] = [],
        params: { [key: string]: string } = {},
    ): Observable<JsonCatalog> {
        let sproducts: JsonCatalog;
        if (Object.keys(this.products).length) {
            this.promise = observableOf(this.products);
            return this.promise;
        }

        sproducts = this.catalogStorageService.getItem(`${this.catalogStorageService.KEY.PRODUCTS}_${type}`);

        if (sproducts) {
            this.products = sproducts;
            this.promise = observableFrom([sproducts]);
            return this.promise;
        }

        if (type === CATALOG_TYPE.FAI) {
            params = { type: 'fai,faim_unlimited,fai_service' };
        }

        if (!this.promise) {
            this.promise = this.oauth2Resource
                .setLocalService(true)
                .useSalesApi()
                .ventes()
                .produits()
                .setParams(params)
                .get()
                .pipe(
                    catchError(this.handleError),
                    map((res) => {
                        this.products = res.produits;
                        if (type !== CATALOG_TYPE.DEFAULT) {
                            this.products.EPD0000000 = {
                                type_id: 'edp',
                                gencode: 'EPD0000000',
                                sku: 'EPD0000000',
                                price: 9999,
                                products_ids: null,
                                name: 'Etalement de paiement',
                                media: null,
                            }; // @todo : is for mock ...
                        }
                        return this.products;
                    }),
                    publishLast(),
                    refCount(),
                );
        }

        return this.promise;
    }
}
